import { MainDrawer } from "components/MainDrawer";

export const PageNotFound = () => {
  return (
    <>
      <MainDrawer>Page not found</MainDrawer>
    </>
  );
};
